import styled from "styled-components";
import { ProductCardBox } from "../../../../../common/cards/product-card/views/mobile/styled.js";
import { ButtonBox } from "../../../../../common/carousels/carousel-product/views/mobile/button-view-more/styled.js";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import { Aside, Highlight, MenuIcon, Title } from "../../components/highlights/styled.js";
export const Highlights = styled.div.withConfig({
    displayName: "styled__Highlights",
    componentId: "sc-672aaa91-0"
})`
	${Aside} {
		${FlexMixin({
    justify: 'space-between',
    align: 'center'
})}
		position: relative;
		padding: 20px 25px;
	}
	${Highlight} {
		${FlexMixin({
    direction: 'column'
})}
		margin-right: 0;
		max-width: 33.3%;
	}
	${MenuIcon} {
		align-self: center;
		width: 60px;
		height: 60px;
		min-width: 60px;
		min-height: 60px;
		${FontMixin({
    size: 'largest'
})}
	}
	${Title} {
		${FontMixin({
    size: 'medium',
    weight: 'light'
})}
	}
`;
export const Coasts = styled.div.withConfig({
    displayName: "styled__Coasts",
    componentId: "sc-672aaa91-1"
})`
	${ButtonBox} {
		a {
			border: none;
			background-color: transparent;
			white-space: unset;
			${FontMixin({
    size: 'medium',
    weight: 'light'
})}
			color: ${({ theme  })=>theme.colors.grays.dark};
			width: 150px;
			text-align: initial;
		}
	}
	${ProductCardBox} {
		background-color: transparent;
		border-top: none;
		border-bottom: none;
	}
`;

//# sourceMappingURL=styled.js.map